import React, { useState } from "react";
import { auth, provider } from "./firebase";
import spaceNeedle from "./Space Needle.jpg";
import {
  signInWithPopup,
  createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail
} from "firebase/auth";

function SignIn() {
  const [mode, setMode] = useState("options");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const loginWithGoogle = async () => {
    setError("");
    try {
      await signInWithPopup(auth, provider);
    } catch (e) {
      console.error("Google sign-in error:", e);
      if (e.code !== "auth/popup-closed-by-user" && e.code !== "auth/cancelled-popup-request") {
        setError("Google sign-in failed. Please try again.");
      }
    }
  };

  const handleEmailAuth = async () => {
    setError("");
    if (!email.trim()) { setError("Please enter your email."); return; }
    if (!password) { setError("Please enter your password."); return; }
    if (mode === "signup" && password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true);
    try {
      if (mode === "signup") await createUserWithEmailAndPassword(auth, email.trim(), password);
      else await signInWithEmailAndPassword(auth, email.trim(), password);
    } catch (e) {
      const msgs = {
        "auth/email-already-in-use": "An account with this email already exists.",
        "auth/invalid-email": "Please enter a valid email address.",
        "auth/wrong-password": "Incorrect password.",
        "auth/user-not-found": "No account found with this email.",
        "auth/too-many-requests": "Too many attempts. Please try again later.",
        "auth/invalid-credential": "Incorrect email or password.",
      };
      setError(msgs[e.code] || "Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  const handleReset = async () => {
    setError("");
    if (!email.trim()) { setError("Please enter your email address first."); return; }
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setResetSent(true);
    } catch (e) { setError("Could not send reset email. Check the address and try again."); }
    setLoading(false);
  };

  return (
    <div className="animate-fade-in" style={{ maxWidth: 420, margin: "0 auto", paddingTop: 20 }}>

      {/* Hero section */}
      <div style={{
        textAlign: "center",
        background: "linear-gradient(135deg, #112240, #162033)",
        border: "1px solid rgba(255,215,0,0.2)",
        borderRadius: 16,
        marginBottom: 24,
        padding: "32px 24px 28px",
        position: "relative",
        overflow: "hidden",
      }}>
        {/* Background glow */}
        <div style={{
          position: "absolute", inset: 0,
          background: "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(255,215,0,0.06) 0%, transparent 70%)",
          pointerEvents: "none",
        }} />

        {/* Space Needle icon */}
        <img
          src={spaceNeedle}
          alt="Ganni Games"
          className="animate-float"
          style={{
            width: 90, height: 90, borderRadius: 20,
            objectFit: "cover",
            filter: "drop-shadow(0 4px 20px rgba(0,0,0,0.5))",
            marginBottom: 16,
          }}
        />

        {/* Brand name */}
        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 36, letterSpacing: 4, lineHeight: 1, marginBottom: 4 }}>
          <span style={{ color: "white" }}>GANNI</span>
          <span style={{ color: "#FFD700" }}>GAMES</span>
        </div>

        <p style={{ color: "rgba(255,255,255,0.45)", fontSize: 14, marginTop: 10 }}>
          We like sports and we don't care who knows.
        </p>
      </div>

      {/* Sign in card */}
      <div className="card" style={{ padding: 24 }}>
        {mode === "options" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <button onClick={loginWithGoogle} className="btn btn-full" style={{
              background: "white", color: "#333", fontSize: 15, padding: "13px 20px", borderRadius: 10
            }}>
              <svg width="18" height="18" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              </svg>
              Continue with Google
            </button>

            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.1)" }} />
              <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 12 }}>OR</span>
              <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.1)" }} />
            </div>

            <button onClick={() => setMode("login")} className="btn btn-outline btn-full" style={{ fontSize: 15, padding: "13px 20px", borderRadius: 10 }}>
              Sign in with Email
            </button>
            <button onClick={() => setMode("signup")} className="btn btn-ghost btn-full" style={{ fontSize: 15, padding: "13px 20px", borderRadius: 10 }}>
              Create Account with Email
            </button>
          </div>
        )}

        {(mode === "login" || mode === "signup") && (
          <div>
            <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 24, color: "#FFD700", letterSpacing: 2, marginBottom: 20 }}>
              {mode === "signup" ? "CREATE ACCOUNT" : "SIGN IN"}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleEmailAuth()}
                placeholder="Email address" className="input" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleEmailAuth()}
                placeholder="Password" className="input" />
            </div>
            {error && <p className="error-text" style={{ marginTop: 10 }}>{error}</p>}
            <button onClick={handleEmailAuth} disabled={loading} className="btn btn-primary btn-full btn-lg" style={{ marginTop: 16, borderRadius: 10 }}>
              {loading ? "..." : mode === "signup" ? "Create Account" : "Sign In"}
            </button>
            {mode === "login" && (
              <button onClick={handleReset} disabled={loading} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.4)", cursor: "pointer", fontSize: 13, marginTop: 12, display: "block", width: "100%", textAlign: "center" }}>
                {resetSent ? "✓ Reset email sent!" : "Forgot password?"}
              </button>
            )}
            <button onClick={() => { setMode("options"); setError(""); setPassword(""); }}
              style={{ background: "none", border: "none", color: "rgba(255,255,255,0.4)", cursor: "pointer", fontSize: 13, marginTop: 8, display: "block", width: "100%", textAlign: "center" }}>
              ← Back
            </button>
          </div>
        )}
      </div>

      <p style={{ textAlign: "center", fontSize: 11, color: "rgba(255,255,255,0.2)", marginTop: 16 }}>
        By signing in you agree to play nice and have fun.
      </p>
    </div>
  );
}

export default SignIn;
